import React from "react";
import { CatalogueController } from "./CatalogueController";
import { CatalogueViewModel } from "./CatalogueViewModel";
import * as feedback from "../../common/Feedback/Feedback";
import * as log from "../../common/Feedback/Log";

export class CatalogueProvider extends React.Component {
  constructor(props) {
    super(props);
    this.viewModel = new CatalogueViewModel();
    this.logger = log;
    this.feedback = feedback;

    console.log(props);
  }

  render() {
    return (
      <CatalogueController
        viewModel={this.viewModel}
        log={this.logger}
        feedback={this.feedback}
        toggleTopbar={this.props.toggleTopbar}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Catalogues/CatalogueProvider.js